import { Project } from 'cmp-client-api';

import { MyProject } from '@src/domain/pages/my-projects/table/types';
import { MapperInterface } from './types/mapper.interface';

const transformFromApiModel = (items: Project[] = []): MyProject[] =>
  items.map((item) => ({
    id: item.id,
    tenantId: item.tenantId,
    type: item.type,
    name: item.name,
    description: item.description,
    projectManager: item.projectManager,
    startDate: item.startDate,
    endDate: item.endDate,
    projectLink: item.projectLink,
    documentLink: item.documentLink,
    repositoryLink: item.repositoryLink,
    isDeleted: item.isDeleted,
  }));

export const MyProjectMapper: MapperInterface<MyProject[], Project[]> = {
  transformFromApiModel,
};
